import {Component, ElementRef, Inject, Input, NgZone, Renderer2, ViewEncapsulation, DOCUMENT, ChangeDetectionStrategy} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {StateService} from '../../app/services/state.service';
import {ApiService} from '../../app/services/api.service';

import {ActivatedRoute, Router} from '@angular/router';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {TranslateService} from '@ngx-translate/core';
import {CoolLocalStorage} from '@angular-cool/storage';
import {FieldErrorService} from '../../app/services/field-error.service';
import {AnalyticsService} from '../../app/services/analytics.service';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {VisitorService} from '../../app/services/visitor.service';
import {CustomerService} from "../../app/services/customer.service";
import {PopupWidgetComponent} from "../popup-widget/popup-widget.component";
import {MatIconRegistry} from "@angular/material/icon";

const apiFormIdProvider = (state: StateService, route: ActivatedRoute) => {
  if (route.parent && route.parent.snapshot) {
    return route.parent.snapshot.params.formId;
  } else {
    return state.formId;
  }
};

@Component({
    selector: 'mobile-popup-widget',
    templateUrl: '../../app/form/order/order.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./mobile-popup-widget.component.scss',
        '../../app/form/order/order.component.scss'],
    providers: [
        {
            provide: 'apiModel',
            useValue: 'orders'
        },
        {
            provide: 'apiFormId',
            useFactory: apiFormIdProvider,
            deps: [StateService, ActivatedRoute]
        },
        ApiService, CustomerService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MobilePopupWidgetComponent extends PopupWidgetComponent {
  // Identifies this widget so the shared template renders the floating button for it (see order.component.html).
  @Input() widgettype: string = 'mobile-popup-widget';
  // RideBits-style "new booker": branded header bar shown by default, blue accent.
  @Input() headercolor: string = '#2f6bff';
  @Input() showtopbar: boolean = true;
  // Launcher button docked bottom-right (matches the RideBits embedded widget); the panel docks
  // bottom-right just above it (see styles.scss .wb-theme-mobilepopup .nsm-dialog).
  @Input() buttonposition: string = 'bottomRight';

  constructor(zone: NgZone,
              iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer,
              http: HttpClient,
              activatedRoute: ActivatedRoute,
              apiService: ApiService,
              modalService: NgxSmartModalService,
              translate: TranslateService,
              vault: CoolLocalStorage,
              router: Router,
              route: ActivatedRoute,
              state: StateService,
              errorService: FieldErrorService,
              analytics: AnalyticsService,
              pageTitle: Title,
              visitorService: VisitorService,
              _customerService: CustomerService,
              _renderer2: Renderer2,
              _iconRegistry: MatIconRegistry,
              _sanitizer: DomSanitizer,
              @Inject('Window') window: Window,
              @Inject(DOCUMENT) document: Document,
              hostEl: ElementRef) {
    super(zone, iconRegistry, sanitizer, http, activatedRoute, apiService, modalService, translate, vault, router,
      route, state, errorService, analytics, pageTitle, visitorService, _customerService, _renderer2, _iconRegistry,
      _sanitizer, window, document, hostEl);

    // Activate the mobile-popup theme. Scoped on <html> so it also reaches the ngx-smart-modal
    // internals (which render in <body>, outside this component's encapsulation).
    document.documentElement.classList.add('wb-theme-mobilepopup');

    // Show the RideBits-style trip-type selector as the first step (gated on form capabilities in
    // OrderComponent). Read later in _ngOnInit (async), so setting it here is safe.
    this.useServiceSelector = true;
  }
}
